export enum ThumbnailType {
  Portrait = 'portrait',
  Card = 'card',
  Square = 'square',
  Poster = 'poster',
  Poster2To3 = 'poster2to3',
  Promotion = 'promotion',
  Banner = 'banner',
  Book = 'book',
  OperationDayOfWeekCardBanner = 'operationDayOfWeekCardBanner',
  OperationDayOfWeekCardBannerMobile = 'operationDayOfWeekCardBannerMobile',
}
